import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

import { HttpClient, HttpHeaders , HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { map , catchError } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class ConfigurationService {
    // base url for all requests
    baseUrl = environment.apiUrl + '/web';

    constructor(private http: HttpClient ) { }

    // getNumplateData(gt: any,lt: any): Observable<any>{
    //     return this.http.get<any>(this.baseUrl + ); 
    //   }

    check_device(serial_no: String) {
        const body = {
            "serialno":serial_no
        }
        return this.http.post(this.baseUrl+'/check_device', body);
    }

    fetch_device(user_data_id: String,serial_no: String) {
        const body = {
            "user_data_id":user_data_id,
            "serialno":serial_no
        }
        return this.http.post(this.baseUrl+'/edge_device', body);
    }

    fetch_group_names(user_data_id: String) {
        const body = {
            "_id" : user_data_id
        }
        return this.http.post(this.baseUrl+'/fetch_groups', body);
    }

    fetch_groups_by_user(user_data_id: String) {
        const body = {
            "_id" : user_data_id
        }
        return this.http.post(this.baseUrl+'/fetch_user_groups', body);
    }

    fetch_devices_in_group(user_data_id: String , group: String) {
        const body = {
            "_id" : user_data_id,
            "group" : group
        }
        return this.http.post(this.baseUrl+'/group_devices', body);
    }

    delete_group(user_data_id: String , group: String , devices_in_group) {
        const body = {
            "_id" : user_data_id,
            "group" : group,
            "devices" : devices_in_group
        }
        return this.http.post(this.baseUrl+'/delete_group', body);
    }

    save_device(serial_no: String , user_data_id: String ,name: String , location: String , group_name: String , new_group: Boolean) {
        const body = {
            "serialno" : serial_no,
            "user_data_id":user_data_id,
            "name": name,
            "location": location,
            "group":group_name,
            "new_group":new_group
        }
        return this.http.post(this.baseUrl+'/add_device', body);
    }

    delete_device(user_data_id: String , serialno: String ) {
        const body = {
            "user_data_id" : user_data_id,
            "serialno" : serialno
        }
        return this.http.post(this.baseUrl+'/delete_device', body);
    }

    update_ip_lists( serial_no: String , connected_ip_devices: Array<String>){
        const body = {
            "serialno" : serial_no,
            "connected_ip_devices" : connected_ip_devices
        }
        return this.http.post(this.baseUrl+'/update_ip_list', body);
    }

    save_va_cam( serial_no: String , va_cam ){
        const body = {
            "serialno" : serial_no,
            "va_cam" : va_cam
        }
        return this.http.post(this.baseUrl+'/addcamera', body);
    }

    save_va_edit_cam( serial_no: String , va_cam , va_cam_id ){
        const body = {
            "serialno" : serial_no,
            "va_cam" : va_cam,
            "va_cam_id" : va_cam_id
        }
        return this.http.post(this.baseUrl+'/saveeditcamera', body);
    }

    delete_va_cam( serial_no: String , va_cam ){
        const body = {
            "serialno" : serial_no,
            "va_cam" : va_cam
        }
        return this.http.post(this.baseUrl+'/removecamera', body);
    }

    fetch_va_filters(user_data_id: String){
        const body = {
            "user_data_id" : user_data_id,
        }
        return this.http.post(this.baseUrl+'/vafilterdata', body);
    }

    fetch_va_alerts(user_data_id: String , filters , skip , limit){
        const body = {
            "user_data_id" : user_data_id,
            "filters" : filters,
            "skip" : skip,
            "limit" : limit
        }
        return this.http.post(this.baseUrl+'/vaalertsdata', body);
    }

    fetch_dash_stats(user_data_id: String , filters , skip , limit){
        const body = {
            "user_data_id" : user_data_id,
            "filters" : filters,
            "skip" : skip,
            "limit" : limit
        }
        return this.http.post(this.baseUrl+'/dashstats', body);
    }

    addSafetyOfficer(user_data_id: String, officer){
        const body = {
            "user_data_id" : user_data_id,
            "officer" : officer,
        }
        return this.http.post(this.baseUrl+'/addsafetyoff', body);
    }

    fetchSafetyOfficer(user_data_id: String ){
        const body = {
            "user_data_id" : user_data_id,
        }
        return this.http.post(this.baseUrl+'/fetchsafetyoff', body);
    }

    deleteSafetyOfficer(user_data_id: String , ref_no_list ){
        const body = {
            "user_data_id" : user_data_id,
            "ref_no_list": ref_no_list
        }
        return this.http.post(this.baseUrl+'/deletesafetyoff', body);
    }

    addAlias(user_data_id: String, alias){
        const body = {
            "user_data_id" : user_data_id,
            "alias" : alias
        }
        return this.http.post(this.baseUrl+'/addalertalias', body);
    }

    fetchAlias(user_data_id: String ){
        const body = {
            "user_data_id" : user_data_id,
        }
        return this.http.post(this.baseUrl+'/fetchalertalias', body);
    }

    deleteAlias(user_data_id: String , alias_list ){
        const body = {
            "user_data_id" : user_data_id,
            "alias_list": alias_list
        }
        return this.http.post(this.baseUrl+'/deletealertalias', body);
    }

}